import { render, staticRenderFns } from "./ModalTutorialResposta.vue?vue&type=template&id=37efa189&"
import script from "./ModalTutorialResposta.vue?vue&type=script&lang=js&"
export * from "./ModalTutorialResposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports